// quiz question page

import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import coin from '../assets/earn-coin.svg';
import { useNavigate, useParams } from 'react-router-dom';
import quizData from '../data/quizdata';
import Adsense from './Adsense';
import { addCoins, CORRECT_REWARD, WRONG_PENALTY } from '../utils/coins';
import coin1 from '../assets/coin.png';

function Quizgame() {
  const { name } = useParams();
  const category = name.toLowerCase().replace(/\s+/g, "-");
  const questions = quizData[category] || [];

  const [currentQ, setCurrentQ] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [wrong, setWrong] = useState(0);
  // const [timeLeft, setTimeLeft] = useState(120); // 2 minutes = 120 sec
  const [timeLeft, setTimeLeft] = useState(200); // 2 minutes = 120 sec

  const [quizEnd, setQuizEnd] = useState(false);

  // ⏱ Timer
  useEffect(() => {
    if (timeLeft <= 0 || quizEnd) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, quizEnd]);

  // End quiz if finished
  useEffect(() => {
    if (currentQ >= questions.length) {
      setQuizEnd(true);
    }
  }, [currentQ]);

  // format time
  const formatTime = () => {
    const min = Math.floor(timeLeft / 60);
    const sec = timeLeft % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleAnswer = (option) => {
    if (selected) return;

    setSelected(option);

    if (option === questions[currentQ].correctAnswer) {
      // correct answer → add coins
      setScore((prev) => prev + 100);
      addCoins(CORRECT_REWARD);
    } else {
      // wrong answer → subtract coins
      setWrong((prev) => prev + 1);
      addCoins(-WRONG_PENALTY);
    }

    setTimeout(() => {
      setSelected(null);
      setCurrentQ((prev) => prev + 1);
    }, 1000);
  };

  const getClass = (option) => {
    if (!selected) return "option-btn2";

    if (option === questions[currentQ].correctAnswer) {
      return "option-btn2 correct";
    }

    if (option === selected) {
      return "option-btn2 wrong";
    }

    return "option-btn2";
  };
  const navigate = useNavigate();

  // 🎯 RESULT SCREEN
 useEffect(() => {
  if (quizEnd || timeLeft <= 0) {
    navigate("/result", {
      state: {
        // net coins for this round: +100 per correct, -100 per wrong (can be negative)
        score: score - wrong * WRONG_PENALTY,
        correct: score / 100,
        wrong,
        total: questions.length,
        category: name,
      },
    });
  }
}, [quizEnd, timeLeft]);

  return (
    <>
           <div className="main">
        <div className="main-div2">
          <div className="container mt-3">
            <div className="">
              <Navbar />
            </div>
              
       <div className="container mt-5 text-center ">
      <h4 className="" style={{color:"#ffcd40"}}>{name.toUpperCase()}</h4>
      <p style={{color:"white",fontSize:"20px",fontWeight:"500"}}>Play and win coin <span><img src={coin} alt="" /></span> 1000 </p>
      {/* 🔥 CATEGORY NAME */}

      {/* ⏱ TIMER + SCORE */}
      <div className='quiz-div '>
      <div className="quiz-top ">

        <div className="score green">{score / 100}</div>

        <div className="timer-circle">
          {formatTime()}
        </div>

        <div className="score red">{wrong}</div>

      </div>

      {/* QUESTION */}
      <h6 className="mt-3 count">
        Question {currentQ + 1}/{questions.length}
      </h6>

      <h5 className="mt-3">
        {questions[currentQ]?.question}
      </h5>

      {/* OPTIONS */}
      <div className="mt-4 option-div">
        {questions[currentQ]?.options.map((opt, i) => (
          <div key={i}>
          <button            
            className={getClass(opt)}
            style={{ margin: 0 }}
            onClick={() => handleAnswer(opt)}
          >
            {opt}
          </button>
          </div>
        ))}
      </div>
</div>
      <h3 className="mt-4 mb-4" style={{color:"#ffcd40"}}>Your Score is {score}</h3>
    </div>
           {/* <div className='mb-4'>
            <Adsense slot="6300978111"/>
            </div> */}
          </div>
        </div>
      </div> 
    </>
  )
}

export default Quizgame
